import type { ModeratorAction } from './constants';

export const MODERATION_DATA_TOPIC = 'moderation';

export type ModeratorIdentityType = 'USER' | 'GUEST';

// todo изменится когда будет готово апи сервера
export type ModeratorRole = 'main' | 'moderator';

/**
 * Информация о модераторе от сервера.
 * Для типа USER: userId установлен, identity null.
 * Для типа GUEST: identity установлен (LiveKit identity), userId null.
 * role: основной модератор (один на комнату) или обычный.
 */
export type RoomModerator = {
    type: ModeratorIdentityType;
    userId: string | null;
    /** Для гостей: identity из LiveKit. */
    identity: string | null;
    role?: ModeratorRole;
};

// кросс-платформенные типы экшенов для модераторов
export type ModerationCommand = {
    action: ModeratorAction;
    targetIdentity?: string;
    targetSid?: string;
    moderatorIdentity?: string;
    moderatorSid?: string;
};
